module.exports = __webpack_public_path__ + "img/pic1_4.ce369720.png";